import {
    ModalV2,
    ModalV2Title,
    ModalV2Content,
    ModalV2Footer,
    ButtonGroup,
    Button,
} from '@design-system-etat/dsfr-react';
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const ModaleValiderAcquisition = ({ armesSelectionnees, fermerModale }) => {
    const dialog = useRef();

    useEffect(() => {
        if (dialog.current) {
            dialog.current.showModal();
        }
    }, [dialog]);
    const getPlurielPhraseUn = () => {
        if (armesSelectionnees.length > 1) {
            return 'des armes';
        }
        return "de l'arme";
    };

    const getPlurielPhraseDeux = () => {
        if (armesSelectionnees.length > 1) {
            return 'vos armes';
        }
        return 'votre arme';
    };

    const recupererNumeroEncodage = () => {
        return armesSelectionnees.map((arme, key) => {
            if (key === 0) {
                return arme.numeroEncodage;
            }
            return `, ${arme.numeroEncodage}`;
        });
    };

    return (
        <ModalV2
            id="acquisition-arme"
            idModalTitle="acquisition-arme-title"
            size="lg"
            onClose={fermerModale}
            ref={dialog}
        >
            <ModalV2Content>
                <ModalV2Title id="acquisition-arme-title">
                    Validation d'acquisition d'armes :
                </ModalV2Title>

                <p>
                    Vous venez de valider l&apos;acquisition {getPlurielPhraseUn()}{' '}
                    {recupererNumeroEncodage()}. Vous retrouverez {getPlurielPhraseDeux()} dans
                    votre râtelier numérique au statut &quot;Détenue&quot;.
                </p>
            </ModalV2Content>
            <ModalV2Footer>
                <ButtonGroup align="right" inline>
                    <Button name="fermer" onClick={fermerModale}>
                        Fermer
                    </Button>
                </ButtonGroup>
            </ModalV2Footer>
        </ModalV2>
    );
};

ModaleValiderAcquisition.propTypes = {
    armesSelectionnees: PropTypes.arrayOf(
        PropTypes.shape({
            numeroEncodage: PropTypes.string.isRequired,
        }).isRequired,
    ),
    fermerModale: PropTypes.func.isRequired,
};

export default ModaleValiderAcquisition;
